import { useHeaders } from "ssr-hook";
import { useTitle } from "easy-page-router/react";

type UseHeadProps = {
    title: string;
    description: string;
    image?: string;
    canonical?: string;
    lang?: string;
};

export function useHead({ title, description, image, canonical, lang }: UseHeadProps) {
    useHeaders({
        title,
        description,
        image: image || `/images/icon.png`, // Images must be placed in the public directory to be accessible
        canonical: canonical || (typeof window !== "undefined" ? window.location.origin + window.location.pathname : ""),
        lang,
    });
    useTitle(title);
}
